import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AppProvider, useApp } from './context/AppContext';
import PublicWebsite from './components/public/PublicWebsite';
import ClientPortal from './components/portal/ClientPortal';

function AppContent() {
  const { currentView } = useApp();
  if (currentView === 'portal') return <ClientPortal />;
  return <PublicWebsite />;
}

export default function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </HelmetProvider>
  );
}
